module.exports = __webpack_public_path__ + "img/regent-seven-logo.49dd3574.png";